import { useEffect, useState } from 'react'

const useAhoy = () => {
  const [ahoy, setAhoy] = useState<any>()

  useEffect(() => {
    const getAhoy = async () => {
      const Ahoy = (await import('ahoy.js')).default
      Ahoy.configure({
        urlPrefix: process.env.REACT_APP_API
      })

      setAhoy(Ahoy)
    }

    getAhoy()
  }, [])

  return ahoy
}

export default useAhoy
